<ng-container *transloco="let t; read: 'widgets.widget-markdown-editor'">
  @if (mode === 'edit') {
    <as-split direction="horizontal">
      <as-split-area [size]="50" [minSize]="25" class="widget-markdown-editor__column">
        <h3>{{ t('markdown') }}</h3>
        <textarea
          [placeholder]="t('add-your-note-here')"
          [ngModel]="content"
          (ngModelChange)="contentChange.emit($event)"
          (blur)="editFinished.emit(true)"
          appAutoFocus
          class="widget-markdown-editor__editor"
        ></textarea>
      </as-split-area>
      <as-split-area [size]="50" [minSize]="25" class="widget-markdown-editor__column">
        <h3>{{ t('preview') }}</h3>
        <ng-container *ngTemplateOutlet="markdownView"></ng-container>
      </as-split-area>
    </as-split>
  } @else {
    <div
      #markdownContainer
      markdown
      [data]="content"
      class="widget-markdown-editor__viewer"
      [class.widget-markdown-editor__viewer--preview]="mode === 'edit'"
    ></div>
  }

  <ng-template #markdownView>
    <div
      #markdownContainer
      markdown
      [data]="content"
      class="widget-markdown-editor__viewer"
      [class.widget-markdown-editor__viewer--preview]="mode === 'edit'"
    ></div>
  </ng-template>
</ng-container>
